module.exports = __webpack_public_path__ + "img/ysgj_007@2x.e564d0b9.png";